<template>
  <router-view :key="this.$route.path"></router-view>
</template>

<script>
export default {};
</script>

<style></style>
